import PropTypes from 'prop-types';
import { memo, useEffect, useState } from 'react';
import Table from '../../../../components/Table/Table';
import { blockedUsersFetchAction } from '../../../../store/fetchActions/blockedUsersActions';
import { useDispatch, useSelector } from 'react-redux';
import Filter from '../../../../components/Filter/Filter';
import { useForm } from 'react-hook-form';
import {
  FirstFilterLine,
  SecondFilterLine,
} from '../../../../components/Filter/Filter.styles';
import TextInput from '../../../../components/TextInput/TextInput';
import DateInput from '../../../../components/DateInput/DateInput';
import Button from '../../../../components/Button/Button';
import { ImSearch } from 'react-icons/im';
import SelectOptions from '../../../../components/SelectOptions/SelectOptions';
import { theme } from '../../../../styles/theme';
import useCallFilter from '../../../../utils/hooks/useCallFilter';
import { LoadingContainer } from '../../styles/GerenciarClientes.styles';
import { CircularProgress } from '@material-ui/core';

const {
  mainColor,
  secondaryColor,
  mainColorButtonHover,
  rbmWhite,
  rbmBlack,
  warningColor,
} = theme.colors;

function UsuariosBloqueados(props) {
  const { value, index } = props;
  const dispatch = useDispatch();
  const { handleSubmit, control } = useForm({
    // resolver: yupResolver(selectValidation),
  });
  const [filterData, setFilterData] = useState('');
  const [filter, setFilter] = useState({
    search: '',
    DATAINICIAL: '',
    DATAFINAL: '',
    orderBy: '',
    limit: 10,
    page: 1,
  });
  useCallFilter(filterData, setFilter, blockedUsersFetchAction, value, index);

  const pagesOptions = [
    { ID: 25, NOME: 25 },
    { ID: 50, NOME: 50 },
    { ID: 100, NOME: 100 },
  ];

  useEffect(() => {
    value === index && (() => dispatch(blockedUsersFetchAction(filter)))();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dispatch, value, index, filter.page]);

  const filterTable = (data) => {
    setFilterData(data);
  };

  const {
    blockedUsersData,
    paginationBlockedUsers,
    loadingBlockedUsers,
    errorBlockedUsers,
    errorMessageBlockedUsers,
  } = useSelector((state) => state.blockedUsers);

  const header = [
    {
      id: 'data de registro',
      name: 'DATA DE REGISTRO',
      align: 'center',
    },
    { id: 'CPFCNPJ', name: 'CPF/CNPJ', align: 'left' },
    { id: 'nome', name: 'NOME', align: 'left' },
    { id: 'conta', name: 'CONTA', align: 'left' },
    {
      id: 'observação',
      name: 'OBSERVAÇÃO',
      align: 'left',
    },
  ];

  const body = blockedUsersData?.map((user) => {
    return {
      data: [
        { info: user.DATA_INSERT, align: 'center' },
        { info: user.CPFCNPJ, align: 'left' },
        { info: user.NOME, align: 'left' },
        { info: user.CONTA, align: 'left' },
        { info: user.MENSAGEM, align: 'left' },
      ],
    };
  });
  return (
    <div hidden={value !== index}>
      <Filter>
        <form onSubmit={handleSubmit(filterTable)}>
          <FirstFilterLine>
            <TextInput
              label="Nome ou CPF/CNPJ"
              name={'search'}
              width={'38.042vw'}
              margin={'0 0 0 1.369vw'}
              control={control}
            />
            <TextInput
              label="Conta"
              name={'CONTA'}
              width={'17.042vw'}
              control={control}
            />
            <DateInput
              label="Data de Início"
              name={'DATAINICIAL'}
              control={control}
            />
            <DateInput
              label="Data Final"
              name={'DATAFINAL'}
              control={control}
            />

            <Button
              backgroundColor={secondaryColor}
              width="12.153vw"
              margin={'0 1.389vw 0 0'}
              hoverBGColor={mainColor}
              hoverColor={rbmBlack}
              color={'white'}
              type="submit"
            >
              <ImSearch className="default-svg" size={'1.181vw'} />
              <span>Buscar</span>
            </Button>
          </FirstFilterLine>

          <SecondFilterLine>
            <h5>Resultados por Página</h5>
            <SelectOptions
              control={control}
              options={pagesOptions}
              name={'limit'}
              width={'5vw'}
              margin={'0 0 0 1.875vw'}
              initialValue={10}
              initialName={10}
            />
            <h5>Total de Registros: {paginationBlockedUsers?.totalResult}</h5>
          </SecondFilterLine>
        </form>
      </Filter>
      {loadingBlockedUsers ? (
        <LoadingContainer>
          <CircularProgress size={'5vw'} color="inherit" />
        </LoadingContainer>
      ) : (
        <Table
          loading={loadingBlockedUsers}
          error={errorBlockedUsers}
          hasPagination={true}
          filter={filter}
          pagination={paginationBlockedUsers}
          setFilter={setFilter}
          errorMessage={errorMessageBlockedUsers}
          filterTable={filterTable}
          header={header}
          body={body}
        />
      )}
    </div>
  );
}

UsuariosBloqueados.propTypes = {
  children: PropTypes.node,
  index: PropTypes.any.isRequired,
  value: PropTypes.any.isRequired,
};

export default memo(UsuariosBloqueados);
